import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import { ApiContainer } from "../utils/api";
import { SET_API_DATA } from "../redux/constants";

const learningExploreAllContainer = () => {
  const { api } = ApiContainer();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const from = queryParams.get("from");
  const id = queryParams.get("id");
  const name = queryParams.get("name");
  const dispatch = useDispatch();
  const exploreAllData = useSelector((state) => state.api.exploreAllData);
  const exploreAllDataLoader = useSelector(
    (state) => state.api?.loader?.exploreAllResult
  );

  const getCategoryReport = async () => {
    if (id) {
      const response = await api({
        method: "GET",
        endPoint:
          from === "learning"
            ? `learning/section/${id}`
            : `learning/courses/category/${id}`,
        showToastMessage: false,
        urlencoded: false,
        needLoader: true,
        parent: "exploreAllResult",
      });

      if (response?.status) {
        dispatch({
          type: SET_API_DATA,
          payload: {
            exploreAllData: response?.data,
          },
        });
      }
    }
  };

  useEffect(() => {
    if (from === "categorys" || from === "learning") {
      getCategoryReport();
    }
  }, [location]);

  return {
    exploreAllData,
    exploreAllDataLoader,
    categoriesName: name,
    from,
  };
};

export default learningExploreAllContainer;
